import React, { useContext } from 'react';
import getClientContent from '../_BrandingProvider/brandContent';
import { ContractContext } from '../contexts/ContractContext';
import { phoneFormat } from './util';

const ClientPhone = ({ type = 'customerService' }) => {
    const {
        data: { clientId }
    } = useContext(ContractContext);
    const phoneData = getClientContent(clientId)?.variableText;
    const { phone } = phoneData ? phoneData[type] : '';
    const formattedNumber = phoneFormat(phone);
    return <>{formattedNumber}</>;
};

export default ClientPhone;
